import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ThermicIndexWithApiComponent } from './components/thermic-index-with-api/thermic-index-with-api.component';

const routes: Routes = [
  {
    path: '',
    component: ThermicIndexWithApiComponent, // or whatever your main component is
    pathMatch: 'full'
  }
];


@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
